<template>
  <el-dialog
    class="taskRelationSetting"
    title="设置关联关系"
    :visible.sync="dialogVisible"
    style="text-align: left;"
    width="400px"
  >
    <div>
      <div class="tip">
        <p>
          <b>状态同步：</b>A->B设置了状态同步, A完成则B自动完成 <br />
          <b>状态约束：</b>A->B设置了状态约束，只有等A的完成，B才能进行完成操作
        </p>
      </div>
      <el-form label-position="right" :model="formData" size="mini">
        <el-form-item label="状态同步">
          <el-switch
            v-model="formData.STATESYNC"
            inactive-color="#FF7777"
          ></el-switch>
        </el-form-item>
        <el-form-item label="状态约束">
          <el-switch
            v-model="formData.STATECONSTRAINS"
            inactive-color="#FF7777"
          ></el-switch>
        </el-form-item>
        <el-form-item v-if="!isMerge" label="关联关系">
          <el-select
            size="medium"
            v-model="formData.RELATIONTYPE"
            @change="selectChange"
            placeholder="请选择"
          >
            <el-option
              v-for="items in relationOptions"
              :key="items.value"
              :label="items.label"
              :value="items.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-else label="合并至任务">
          <el-select
            v-model="formData.TASKID"
            size="mini"
            @change="selectChange"
            placeholder="请选择"
          >
            <el-option
              v-for="items in taskList"
              :key="items.ID"
              :label="items.TASKNAME"
              :value="items.ID"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="clear">取 消</el-button>
      <el-button type="primary" @click="save">确认</el-button>
    </div>
  </el-dialog>
</template>
//任务关联
<script>
export default {
  props: {
    taskList: {
      //是否是任务合并
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      isMerge: false,
      formData: {
        RELATIONTYPE: 0,
        TASKID: "",
        STATESYNC: false,
        STATECONSTRAINS: false
      },
      relationOptions: [
        {
          label: "普通关系",
          value: 0
        },
        {
          label: "合并关系",
          value: 1
        },
        {
          label: "因果关系",
          value: 2
        }
      ]
    };
  },
  watch: {
    taskList(newValue) {
      if (newValue.length > 0) {
        this.isMerge = true;
        this.formData.RELATIONTYPE = 1;
        this.formData.TASKID = newValue[0].ID;
      }
    }
  },
  methods: {
    selectChange(val) {
      if (val == 1) {
        this.formData.STATESYNC = true;
        this.formData.STATECONSTRAINS = false;
      } else if (val == 2) {
        this.formData.STATESYNC = false;
        this.formData.STATECONSTRAINS = true;
      }
    },
    clear() {
      this.isMerge = false;
      this.dialogVisible = false;
      this.formData = {
        RELATIONTYPE: 0,
        TASKID: "",
        STATESYNC: false,
        STATECONSTRAINS: false
      };
    },
    save() {
      this.$emit("setRelation", Object.assign({}, this.formData));
      this.clear();
    }
  }
};
</script>

<style lang="scss" scoped>
.tip {
  padding: 8px 16px;
  background-color: #ecf8ff;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
  margin: 20px 0;
}

.tip p {
  font-size: 14px;
  color: #5e6d82;
  line-height: 1.5em;
  margin: 12px 0px !important;
  padding: auto !important;
}
</style>
<style>
.taskRelationSetting .el-dialog__body {
  padding: 0 20px !important;
}
</style>
